module.exports = __webpack_public_path__ + "img/sigma.4b8f37fd.webp";